import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCalendarAdd4: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconCalendarAdd4"><Path fillRule="evenodd" clipRule="evenodd" d="M7 4H3V21H21V4H17V2H15V4H9V2H7V4ZM12.9991 9H10.9991V11.5H8.5V13.5H10.9991V16H12.9991V13.5H15.5V11.5H12.9991V9Z" fill="currentColor"/></CentralIconBase>;
});

export default IconCalendarAdd4;
